/* eslint-disable max-len */
import { toastr } from 'react-redux-toastr';
import {
    pendingTask,
    begin,
    end,
} from 'react-redux-spinner';
import AuthService from '@commonClient2/services/auth';
import {
    UPDATE_EMPLOYEE_BIDDING_RESULTS_REPORT,
} from './employeeBiddingResultsReport.actions';
import { LOADING_END, LOADING_START } from '../loading';
import * as apiManager from '../../Manager/services/api-endpoints';
import * as apiEmployee from '../../Employee/services/api-endpoints';
import FileService from '../../services/FileService';
import DateFormatService from '../../services/DateFormatService';
import { UkgDateFormat } from '../../Enums';
import i18n from '../../services/i18n';


/**
 * @param {BidProfile.IScheduleTemplateItem} item
 * @param {number} index
 * @returns {EmployeeBidProfile.IGroupedScheduleTemplateItems}
 */
const prepareTableItem = (item, index) => {
    const weeklyHeight = Object.keys(item.maxDayPerWeek).map((x) => item.maxDayPerWeek[Number(x)]);
    /** @type {BidProfile.ISchedulePatternTemplateItem[][][]} */
    const shifts = [];
    item.schedulePatternTemplate.items.forEach((shift) => {
        const week = Math.floor((shift.day - 1) / 7);
        const dayOfWeek = (shift.day - 1) % 7;
        if (shifts[week] === undefined) {
            shifts[week] = [[], [], [], [], [], [], []];
        }

        shifts[week][dayOfWeek].push(shift);
    });
    return {
        groupId: '',
        quantity: 1,
        position: index,
        scheduleTemplateNameList: [item.schedulePatternTemplate.name],
        ...item,
        weeklyHeight,
        shifts,
        tableOrder: -1, // TODO : make these obsolete
        rowClassName: '', // TODO : make these obsolete
        approvedRow: true,
    };
};

/**
 * @param {string} profileId
 * @param {{
 *   employeeIds: number[]
 *   searchQuery: string
 *   pageIndex: number
 *   pageSize: number
 *   sortColumn: number
 *   isSortAscending: boolean
 *   dataviewKeyAlias: string[]
 *   isRankReport: boolean
 * }} searchParams
 */
export const loadEmployeeBiddingResults = (profileId, searchParams) =>
    /** @param {import('redux').Dispatch} dispatch */async (dispatch) => {
        try {
            dispatch({ type: LOADING_START, [pendingTask]: begin });

            const result = AuthService.isManager()
                ? await apiManager.getEmployeeBidResult(profileId, searchParams)
                : await apiEmployee.getEmployeeBidResult(profileId, searchParams);
            if (result.status === 200) {
                /** @type {EmployeeBiddingResultsReport.IEmployeeBidResult[]} */
                const preparedEmployeeResults = result.data.employeeResults.map((x, index) => ({
                    employeeId: x.employeeId,
                    rank: x.employeeRank,
                    name: x.employeeFullName,
                    scheduledOn: (x.submissionStartDate && x.submissionEndDate) ? DateFormatService.formatPeriod(
                        x.submissionStartDate,
                        x.submissionEndDate,
                        UkgDateFormat.ShortDateTime,
                    ) : 'Appended',
                    groupedAwardedItem: x.awardedItem ? prepareTableItem(x.awardedItem, index) : null,
                    isLocked: x.isLocked,
                    status: x.status,
                }));
                return dispatch({
                    type: UPDATE_EMPLOYEE_BIDDING_RESULTS_REPORT,
                    payload: {
                        ...result.data,
                        preparedEmployeeResults,
                        pagination: {
                            pageIndex: Math.min(Math.max(searchParams.pageIndex + 1, 1), Math.ceil(result.data.totalCount / searchParams.pageSize)),
                            pageSize: searchParams.pageSize,
                            totalCount: result.data.totalCount,
                        },
                    },
                });
            }
            toastr.error(i18n.t('shiftBidding:toastr.fetchingEmployeeBiddingResultsReport'), i18n.t('shiftBidding:toastr.failedToFetchEmployeeBiddingResultsReport'));
            return Promise.reject();
        } catch (error) {
            toastr.error(i18n.t('shiftBidding:toastr.fetchingEmployeeBiddingResultsReport'), error.response.data.Message);
            return Promise.reject(error);
        } finally {
            dispatch({ type: LOADING_END, [pendingTask]: end });
        }
    };

/**
 * @param {string} profileId
 * @param {number[]} employeeIds
 * @param {string[]} dataviews
 * @param {string} searchQuery
 * @param {boolean} isRankReport
 */
export const downloadReportAsCsv = (profileId, employeeIds, dataviews, searchQuery, isRankReport) => /** @param {import('redux').Dispatch} dispatch */async (dispatch) => {
    try {
        dispatch({ type: LOADING_START, [pendingTask]: begin });
        const response = isRankReport
            ? await apiManager.DownloadEmployeeRank(profileId, employeeIds, dataviews, searchQuery)
            : await apiManager.DownloadEmployeeBidResult(profileId, employeeIds, dataviews, searchQuery);

        if (response.status === 200) {
            FileService.downloadContentInFile(isRankReport ? 'EmployeeRank' : 'EmployeeBidResult', 'csv', response.data);
        } else {
            toastr.error(i18n.t('shiftBidding:toastr.downloadingCSVFile'), i18n.t('shiftBidding:toastr.failedToDownload'));
        }
    } catch (error) {
        toastr.error(i18n.t('shiftBidding:toastr.downloadingCSVFile'), i18n.t('shiftBidding:toastr.failedToDownload'));
    } finally {
        dispatch({ type: LOADING_END, [pendingTask]: end });
    }
};
